/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  BankAccountApiResource,
  CreatePlaidBankAccountsRequest,
  PostApiPlaidCreateLinkToken200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiPlaidCreateAccountsResponse200 = {
  data: BankAccountApiResource[]
  status: 200
}

export type postApiPlaidCreateAccountsResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPlaidCreateAccountsResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPlaidCreateAccountsResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiPlaidCreateAccountsResponseSuccess = (postApiPlaidCreateAccountsResponse200) & {
  headers: Headers;
};
export type postApiPlaidCreateAccountsResponseError = (postApiPlaidCreateAccountsResponse400 | postApiPlaidCreateAccountsResponse401 | postApiPlaidCreateAccountsResponse403) & {
  headers: Headers;
};

export type postApiPlaidCreateAccountsResponse = (postApiPlaidCreateAccountsResponseSuccess | postApiPlaidCreateAccountsResponseError)

export const getPostApiPlaidCreateAccountsUrl = () => {


  

  return `/api/bank-accounts/plaid/create`
}

export const postApiPlaidCreateAccounts = async (createPlaidBankAccountsRequest: CreatePlaidBankAccountsRequest, options?: RequestInit): Promise<postApiPlaidCreateAccountsResponse> => {
  
  return customFetch<postApiPlaidCreateAccountsResponse>(getPostApiPlaidCreateAccountsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPlaidBankAccountsRequest,)
  }
);}


export type postApiPlaidCreateLinkTokenResponse200 = {
  data: PostApiPlaidCreateLinkToken200
  status: 200
}

export type postApiPlaidCreateLinkTokenResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}
    
export type postApiPlaidCreateLinkTokenResponseSuccess = (postApiPlaidCreateLinkTokenResponse200) & {
  headers: Headers;
};
export type postApiPlaidCreateLinkTokenResponseError = (postApiPlaidCreateLinkTokenResponse401) & {
  headers: Headers;
};

export type postApiPlaidCreateLinkTokenResponse = (postApiPlaidCreateLinkTokenResponseSuccess | postApiPlaidCreateLinkTokenResponseError)

export const getPostApiPlaidCreateLinkTokenUrl = () => {


  

  return `/api/bank-accounts/plaid/link-token`
}

export const postApiPlaidCreateLinkToken = async ( options?: RequestInit): Promise<postApiPlaidCreateLinkTokenResponse> => {
  
  return customFetch<postApiPlaidCreateLinkTokenResponse>(getPostApiPlaidCreateLinkTokenUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


export type getApiPlaidAuthCallbackResponse200 = {
  data: void
  status: 200
}
    
export type getApiPlaidAuthCallbackResponseSuccess = (getApiPlaidAuthCallbackResponse200) & {
  headers: Headers;
};
;

export type getApiPlaidAuthCallbackResponse = (getApiPlaidAuthCallbackResponseSuccess)

export const getGetApiPlaidAuthCallbackUrl = () => {


  

  return `/api/bank-accounts/plaid/auth`
}

export const getApiPlaidAuthCallback = async ( options?: RequestInit): Promise<getApiPlaidAuthCallbackResponse> => {
  
  return customFetch<getApiPlaidAuthCallbackResponse>(getGetApiPlaidAuthCallbackUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


